// @flow
import React from 'react'
import { connect } from 'react-redux'
import { httpGet, httpDelete, httpPut } from 'lib/http'
import { setBanner, setLoad, setUnload } from 'lib/notification/actions'
import { unsetModal } from 'lib/modal/actions'
import ClosingDateForm from './ClosingDateForm'
import ClosingEventForm from './ClosingEventForm'
import ClosingFeeForm from './ClosingFeeForm'
import DateOfDeathForm from './DateOfDeathForm'
import { setModal } from 'lib/modal/actions'
import { Template } from './Template'
import { withRouter } from 'lib/hooks/withRouter'

type Props = {
  dispatch: Function,
  location: Object,
}

type State = {
  isConfirmingDelete: boolean,
  dateOfDeath: Date,
  daysSinceLastAnnualFee: number,
  events: [Object],
  notes: [Object],
  nextActions: [Object],
  nextActionDueDates: Object,
  number: String,
  isLoading: boolean,
  closing_fee_data: ?{
    date: string,
    amount: number,
  },
  was_final_tax_fee_taken: boolean,
  is_individual_account: boolean,
}

class ClosingEdit extends React.Component<Props, State> {
  props: Props

  constructor(props) {
    super(props)
    this.state = {
      isConfirmingDelete: false,
      events: [],
      notes: [],
      nextActions: [],
      nextActionDueDates: {},
      daysSinceLastAnnualFee: null,
      isLoading: true,
      closing_fee_data: null,
      was_final_tax_fee_taken: false,
      is_individual_account: false,
    }
  }

  componentDidMount() {
    const { location } = this.props
    const { id } = location.params
    this.setState({ number: id })
    this.fetchClosing(id)
  }

  fetchClosing = (id) => {
    const number = this.state.number || id

    if (number) {
      this.setState({ isLoading: true })
      this.props.dispatch(setLoad())

      httpGet(`/admin/closings/${number}`)
        .then((data) => {
          this.setState({
            dateOfDeath: data.date_of_death,
            daysSinceLastAnnualFee: data.days_since_last_annual_fee,
            events: data.events,
            notes: data.notes,
            nextActions: data.next_actions,
            nextActionDueDates: data.next_action_due_dates || {},
            closing_fee_data: data.closing_fee_data || null,
            was_final_tax_fee_taken: data.was_final_tax_fee_taken || false,
            is_individual_account: data.is_individual_account || false,
            isLoading: false,
          })
          this.props.dispatch(setUnload())
        })
        .catch((err) => {
          this.setState({ isLoading: false })
          this.props.dispatch(setBanner('Error loading closing data', 'danger'))
          this.props.dispatch(setUnload())
        })
    }
  }

  openAttachmentModal = () => {
    const modalForm = <AttachmentForm accountNumber={this.state.number} dispatch={this.props.dispatch} onSuccess={this.fetchClosing} />
    this.props.dispatch(setModal(modalForm))
  }

  openClosingDateModal = () => {
    const today = new Date()
    const modalForm = (
      <ClosingDateForm
        accountNumber={this.state.number}
        date={today}
        dispatch={this.props.dispatch}
        handleUpdateClosingDate={this.handleUpdateClosingDate}
      />
    )

    this.props.dispatch(setModal(modalForm))
  }

  openClosingEventModalCreate = (event) => {
    const modalForm = (
      <ClosingEventForm
        accountNumber={this.state.number}
        dispatch={this.props.dispatch}
        event={event}
        nextActionDueDates={this.state.nextActionDueDates}
      />
    )
    this.props.dispatch(setModal(modalForm))
  }

  openClosingEventModalUpdate = (eventObject) => {
    const modalForm = (
      <ClosingEventForm
        accountNumber={this.state.number}
        dispatch={this.props.dispatch}
        eventObject={eventObject}
        nextActionDueDates={this.state.nextActionDueDates}
      />
    )
    this.props.dispatch(setModal(modalForm))
  }

  openClosingFeeModal = () => {
    const modalForm = <ClosingFeeForm accountNumber={this.state.number} />
    this.props.dispatch(setModal(modalForm))
  }

  openDateOfDeathModal = () => {
    const modalForm = (
      <DateOfDeathForm
        accountNumber={this.state.number}
        dateOfDeath={this.dateOfDeath}
        dispatch={this.props.dispatch}
        handleUpdateDateOfDeath={this.handleUpdateDateOfDeath}
      />
    )

    this.props.dispatch(setModal(modalForm))
  }

  handleActionDelete = (number, id) => {
    const { dispatch } = this.props
    dispatch(setLoad())
    const url = `/admin/closings/${number}/events/${id}`
    return httpDelete(url)
      .then(() => {
        dispatch(setBanner('Action successfully deleted'))
        this.fetchClosing(id)
      })
      .catch(() => {
        dispatch(setBanner('Action deletion failed', 'danger'))
      })
      .then(() => {
        dispatch(unsetModal())
        dispatch(setUnload())
      })
  }

  handleUpdateClosingDate = (close_date) => {
    const { dispatch } = this.props
    const { number, id } = this.state

    dispatch(setLoad())
    const url = `/admin/closings/${number}`
    return httpPut(url, { close_date })
      .then(() => {
        dispatch(setBanner('Account closed successfully'))
        this.fetchClosing(id)
      })
      .catch(() => {
        const msg = 'Error while closing account. Please go to ' + 'Account Page > Edit Account and check ' + 'for any missing documents.'
        dispatch(setBanner(msg, 'danger'))
      })
      .then(() => {
        dispatch(unsetModal())
        dispatch(setUnload())
      })
  }

  handleUpdateDateOfDeath = (date_of_death) => {
    const { dispatch } = this.props
    const { number, id } = this.state

    dispatch(setLoad())
    const url = `/admin/closings/${number}`
    return httpPut(url, { date_of_death })
      .then(() => {
        dispatch(setBanner('DOD successfully updated'))
        this.fetchClosing(id)
      })
      .catch(() => {
        dispatch(setBanner('DOD update failed', 'danger'))
      })
      .then(() => {
        dispatch(unsetModal())
        dispatch(setUnload())
      })
  }

  render() {
    return (
      <Template
        dispatch={this.props.dispatch}
        dateOfDeath={this.state.dateOfDeath}
        daysSinceLastAnnualFee={this.state.daysSinceLastAnnualFee}
        number={this.state.number}
        events={this.state.events}
        notes={this.state.notes}
        nextActions={this.state.nextActions}
        onSuccess={this.fetchClosing}
        openAttachmentModal={this.openAttachmentModal}
        openClosingDateModal={this.openClosingDateModal}
        openClosingEventModalCreate={this.openClosingEventModalCreate}
        openClosingEventModalUpdate={this.openClosingEventModalUpdate}
        openClosingFeeModal={this.openClosingFeeModal}
        openDateOfDeathModal={this.openDateOfDeathModal}
        handleActionDelete={this.handleActionDelete}
        isLoading={this.state.isLoading}
        closing_fee_data={this.state.closing_fee_data}
        was_final_tax_fee_taken={this.state.was_final_tax_fee_taken}
        is_individual_account={this.state.is_individual_account}
      />
    )
  }
}

export default withRouter(connect()(ClosingEdit))
